import { render, staticRenderFns } from "./CustomersIcon.vue?vue&type=template&id=573821c6&scoped=true"
var script = {}
import style0 from "./CustomersIcon.vue?vue&type=style&index=0&id=573821c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573821c6",
  null
  
)

export default component.exports